import { ref } from 'vue';

import Api from '@/api/Api';

import { showErrorMessage } from '@/components/common/errorMessage';
import { sortCnetNumbersWithCurrentWeekLast } from '@/components/common/cnetPublicationUtils';

const useCNetNumberSelectData = (initialCnetNumberRef, onSuccess) => {
	const isLoadingCNetList = ref(false);
	const cnetNumberOptions = ref([]);
	const cnetPublications = ref([]);
	const loadCNetNumbers = () => {
		isLoadingCNetList.value = true;
		Api.cNetNumberListGetList(response => {
			if (response.status === 'ok') {
				const numbers = initialCnetNumberRef.value != null
					? [initialCnetNumberRef.value, ...response.cnetNumberList.filter(num => num !== initialCnetNumberRef.value)]
					: response.cnetNumberList.slice();
				const sortedNumbers = sortCnetNumbersWithCurrentWeekLast(
					numbers,
					response.currentWeekPublishedCnetNumbers ?? [],
				);
				cnetPublications.value = response.publications ?? [];
				cnetNumberOptions.value = sortedNumbers.map(value => ({
					value: value,
					label: 'C-Net ' + value,
				}));
				if (onSuccess != null) {
					onSuccess();
				}
			} else {
				showErrorMessage(response.errors);
			}
			isLoadingCNetList.value = false;
		});
	};
	return {
		isLoadingCNetList,
		cnetNumberOptions,
		cnetPublications,
		loadCNetNumbers,
	};
};

export { useCNetNumberSelectData };
